import { render, staticRenderFns } from "./ChildSourceGrammar.vue?vue&type=template&id=37c6746a&"
import script from "./ChildSourceGrammar.vue?vue&type=script&lang=js&"
export * from "./ChildSourceGrammar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports